import type { PaymentAdapter } from "./customGatewayAdapter";
import { normalizeResponse } from "../core/normalizeResponse";

export const redirectAdapter: PaymentAdapter = async (session, input) => {
  const url = session.redirectUrl ?? session.checkoutUrl;

  if (!url) {
    return normalizeResponse({
      status: "pending",
      input,
      rawResponse: session,
      message: "Payment session created"
    });
  }

  window.location.assign(url);
  return normalizeResponse({
    status: "pending",
    input,
    rawResponse: session,
    message: "Payment redirected"
  });
};
